import { useQuery } from '@tanstack/react-query';

import { StudentInvitationPage } from '$/pages/InvitationPage/components/StudentInvitationPage';
import { TeacherInvitationPage } from '$/pages/InvitationPage/components/TeacherInvitationPage';
import { NotFoundPage } from '$/pages/NotFoundPage';
import { InvitationRoute } from '$/routes/InvitationRoute';
import { invitationRequestQuery } from '$/services/usecases/invitation/queries';

export const InvitationPage = () => {
  const { id } = InvitationRoute.useParams();
  const { data: invitationRequest, isPending } = useQuery(
    invitationRequestQuery(id),
  );

  const invitation = invitationRequest?.response;

  if (isPending) return null;

  switch (invitation?.type) {
    case 'student':
      return <StudentInvitationPage invitation={invitation} />;
    case 'teacher':
      return <TeacherInvitationPage invitation={invitation} />;
    default:
      return <NotFoundPage />;
  }
};
